export default __webpack_public_path__ + "static/media/Remorse.bcd947b8.jpg";